module.exports = __webpack_public_path__ + "static/pic_pcStudent-673a5ca29db1f5c4d9dc57e85df1ce71.png";